export const APP_NAME = "mem.pm";

export const BOARD_ROLES = ["admin", "contributor", "recipient"] as const;

export const MESSAGE_TYPES = ["love", "thinking_of_you", "encouragement", "custom"] as const;

export const ANIMATION_TYPES = ["hearts", "stars", "sparkles", "confetti", "text_wave"] as const;

export const DASHBOARD_NAV = [
	{ href: "/dashboard", label: "Overview" },
	{ href: "/dashboard/billing", label: "Billing" },
	{ href: "/dashboard/activity", label: "Activity" },
	{ href: "/dashboard/settings", label: "Settings" },
] as const;

export const PLANS = [
	{
		id: "free",
		name: "Free",
		priceLabel: "$0",
		description:
			"Core auth, dashboard shell, and starter workflows for validation.",
	},
	{
		id: "pro",
		name: "Pro",
		priceLabel: "$29",
		description:
			"Stripe billing, AI endpoints, activity logs, and newsletter tooling.",
	},
	{
		id: "enterprise",
		name: "Enterprise",
		priceLabel: "Custom",
		description:
			"Custom integrations, multi-user extensions, and deployment support.",
	},
] as const;

export const ACTIVITY_ACTIONS = [
	"login",
	"logout",
	"dashboard_visit",
	"subscription_change",
	"feature_usage",
] as const;

export const AI_FEATURES = [
	"chat",
	"summarize",
	"image",
	"tts",
	"stt",
	"ocr",
] as const;

// ─── Slide durations (kiosk display) ────────────────────────────
// Stockés en ms côté DB/API, exposés en secondes dans l'UI.
export const MIN_SLIDE_DURATION_MS = 2_000;
export const MAX_SLIDE_DURATION_MS = 180_000;
export const DEFAULT_MESSAGE_DURATION_MS = 10_000;
export const DEFAULT_IMAGE_DURATION_MS = 15_000;
export const DEFAULT_WEATHER_DURATION_MS = 12_000;

// ─── Weather cards ─────────────────────────────────────────────
export const WEATHER_LAYOUTS = ["current", "current_today", "forecast_3day", "clock"] as const;
export const WEATHER_STYLES = ["warm", "minimal"] as const;

export const DEFAULT_BOARD_SETTINGS = {
	slideInterval: 10,
	theme: "warm",
	nightModeStart: "22:00",
	nightModeEnd: "07:00",
	timezone: "Europe/Paris",
	messageDurationMs: DEFAULT_MESSAGE_DURATION_MS,
	imageDurationMs: DEFAULT_IMAGE_DURATION_MS,
	weatherDurationMs: DEFAULT_WEATHER_DURATION_MS,
} as const;
